import axios from "axios";

axios.defaults.withCredentials = true;

// Combined response interceptor for handling authentication/authorization errors (401/403)
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check if we're already on an authentication page to avoid redirect loops
    const isAuthPage = window.location.pathname.includes("/pages/authentication/");
    
    if (error?.response?.status === 401 && !isAuthPage) {
      // Save current location for redirect back after login
      const from = window.location.pathname;
      // Force navigation to login page
      window.location.href = `/pages/authentication/simple/sign-in?from=${encodeURIComponent(from)}`;
      return new Promise(() => {}); // Prevent further error handling
    }  
    
    return Promise.reject(error);
  }
);

